import { AmountWithCurrency } from "core/services/cef/types";
import UrlUtils from "./url-utils";

const currencyString = (value: number | AmountWithCurrency, currencyCode: string | undefined = undefined) => {

    const amount = (value as AmountWithCurrency);
    const amountValue = amount.value ?? value;

    currencyCode = currencyCode ?? amount.currencyCode;

    const localeCode = UrlUtils.getLanguageCode();

    const formattedAmount = new Intl.NumberFormat(localeCode, { style: "currency", currency: currencyCode }).format(amountValue)

    return currencyCode.toUpperCase() === "NAD" && formattedAmount.startsWith("$")
        ? `N${formattedAmount}`
        : formattedAmount;
}

export default currencyString;
